import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import {
  GET_QUESTIONS,
  UPDATE_QUESTION_STATUS,
  DELETE_QUESTION,
  ADD_QUESTION,
  GET_QUESTION_DETAILS,
  IMPORT_QUESTIONS_DATA,
  EDIT_QUESTION,
} from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { logout } from "../../utils";
import {
  GetQuestionsSuccess,
  GetQuestionsFailure,
  UpdateQuestionStatusSuccess,
  UpdateQuestionStatusFailure,
  DeleteQuestionSuccess,
  DeleteQuestionFailure,
  AddQuestionSuccess,
  AddQuestionFailure,
  GetQuestionDetailsSuccess,
  GetQuestionDetailsFailure,
  ImportDataSuccess,
  ImportDataFailure,
  EditQuestionsSuccess,
  EditQuestionsFailure,
} from "../Actions/QuestionAction";

function* GetQuestionRequest(actions) {
  let status = "";
  if (actions.payload.status === undefined) {
    status = "";
  } else {
    status = actions.payload.status;
  }

  try {
    const res = yield axios.get(
      `${process.env.REACT_APP_API_URL}api/admin/questions?status=${status}`,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(GetQuestionsSuccess(res.data));
    } else {
      yield put(GetQuestionsFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetQuestionsFailure(e));
  }
}

function* UpdateQuestionStatusRequest(actions) {
  const body = {
    id: actions.payload.id,
    status: actions.payload.status,
  };
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/change_question_status`,
      body,
      {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      }
    );
    if (res.status === 200) {
      yield put(UpdateQuestionStatusSuccess(res.data));
    } else {
      yield put(UpdateQuestionStatusFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateQuestionStatusFailure(e));
  }
}

function* DeleteQuestionRequest(actions) {
  try {
    const res = yield axios.delete(
      `${process.env.REACT_APP_API_URL}api/admin/question/${actions.payload}`,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(DeleteQuestionSuccess(res.data));
    } else {
      yield put(DeleteQuestionFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(DeleteQuestionFailure(e));
  }
}

function* AddQuestionRequest(actions) {
  const body = {
    question: {
      title: actions.payload.title,
      error_text: actions.payload.error_text,
      placeholder_text: actions.payload.placeholder_text,
      min_validation: actions.payload.min_validation,
      max_validation: actions.payload.max_validation,
      type: actions.payload.type,
      input_type: actions.payload.input_type,
      url: actions.payload.url,
      category: actions.payload.category,
    },
    options:
      actions.payload.type === "3" ||
      actions.payload.type === "4" ||
      actions.payload.type === "7"
        ? actions.payload.options
        : "",
  };

  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/add_question`,
      body,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(AddQuestionSuccess(res.data));
    } else {
      yield put(AddQuestionFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(AddQuestionFailure(e));
  }
}

function* GetQuestionDetailsRequest(actions) {
  try {
    const res = yield axios.get(
      `${process.env.REACT_APP_API_URL}api/admin/question_details/${actions.payload}`,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(GetQuestionDetailsSuccess(res.data));
    } else yield put(GetQuestionDetailsFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetQuestionDetailsFailure(e));
  }
}

function* ImportDataRequest(actions) {
  let data = [];
  actions &&
    actions.payload &&
    actions.payload.map((obj) => {
      if (obj.Options && obj.Options.length) {
        obj.Options = obj.Options.split(",");
      }
      data.push(obj);
    });
  const body = {
    data,
  };
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/import_questions_data`,
      body,
      {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      }
    );
    if (res.status === 200) {
      yield put(ImportDataSuccess(res.data));
    } else {
      yield put(ImportDataFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(ImportDataFailure(e));
  }
}

function* EditQuestionRequest(actions) {
  const body = {
    question: {
      id: actions.payload.id,
      title: actions.payload.title,
      error_text: actions.payload.error_text,
      placeholder_text: actions.payload.placeholder_text,
      min_validation: actions.payload.min_validation,
      max_validation: actions.payload.max_validation,
      type: actions.payload.type,
      input_type: actions.payload.input_type,
      url: actions.payload.url,
      category: actions.payload.category,
    },
    options:
      actions.payload.type === "3" ||
      actions.payload.type === "4" ||
      actions.payload.type === "7"
        ? actions.payload.options
        : "",
  };

  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/edit_question`,
      body,
      { headers: defaultHeaders() }
    );
    if (res.status === 200) {
      yield put(EditQuestionsSuccess(res.data));
    } else yield put(EditQuestionsFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(EditQuestionsFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_QUESTIONS, GetQuestionRequest);
  yield takeLatest(UPDATE_QUESTION_STATUS, UpdateQuestionStatusRequest);
  yield takeLatest(DELETE_QUESTION, DeleteQuestionRequest);
  yield takeLatest(ADD_QUESTION, AddQuestionRequest);
  yield takeLatest(GET_QUESTION_DETAILS, GetQuestionDetailsRequest);
  yield takeLatest(IMPORT_QUESTIONS_DATA, ImportDataRequest);
  yield takeLatest(EDIT_QUESTION, EditQuestionRequest);
}

export default function* QuestionSaga() {
  yield all([actionWatcher()]);
}
